<template>
	<up-popup :show="show" mode="center" :round="16" :closeOnClickOverlay="closeOnClickOverlay" :zIndex="zIndex">
		<view class="box-border w-full app-width md:app-pc-width text-center p-[48rpx] pb-0">
			<view class="icon mb-[48rpx]" v-if="icon">
				<image :src="icon" class="w-[288rpx] h-[288rpx]" mode="aspectFit" />
			</view>
			<view class="font-bold mb-1">
				{{ title }}
			</view>
			<view class="text-[#808080] content" v-html="content">
			</view>

			<view class="footer mt-[48rpx]">
				<up-row :gutter="16" customStyle="flex-wrap: wrap;">
					<up-col :span="cancelSpan" v-if="showCancel">
						<up-button type="primary" :plain="true" shape="circle" :text="cancelText || t('common.cancel')"
							@click="onCancel"></up-button>
					</up-col>
					<up-col :span="!showCancel ? 12 : confirmSpan">
						<up-button type="primary" shape="circle" :text="confirmText || t('common.confirm')"
							@click="onConfirm"></up-button>
					</up-col>

				</up-row>
			</view>
		</view>
	</up-popup>
</template>

<script setup>
	import {
		useI18n
	} from 'vue-i18n'
	const {
		t
	} = useI18n()
	import {
		ref,
		reactive,
		defineProps,
		defineEmits,
		onMounted
	} from 'vue'

	const {
		show,
		icon,
		title,
		content,
		confirmText,
		cancelText,
		closeOnClickOverlay,
		showCancel,
	} = defineProps({
		show: {
			type: Boolean,
		},
		icon: String,
		title: {
			type: String,
			default: ''
		},
		content: {
			type: String,
			default: ''
		},
		confirmText: {
			type: String,
			default: ''
		},
		cancelText: {
			type: String,
			default: ''
		},
		showCancel: {
			type: Boolean,
			default: true
		},
		closeOnClickOverlay: {
			type: Boolean,
			default: false
		},
		confirmSpan: {
			type: Number,
			default: 6
		},
		cancelSpan: {
			type: Number,
			default: 6
		},
		zIndex: Number,
	})

	const emit = defineEmits(["update:show", "confirm", "cancel"])

	const onCancel = () => {
		emit("update:show", false);
		emit("cancel");
	}

	const onConfirm = () => {
		emit("update:show", false);
		emit("confirm");
	}
</script>

<style scoped lang="scss">
	.content {
		max-height: 50vh;
		overflow-y: auto;
	}
	::v-deep {
		.u-popup__content {
			width: 90%;
			max-width: 700rpx;
		}
	}
</style>